import React from "react";
import './class-assignment-details.scss';
import Loading from "../../common/loading/loading";
import PaginationComponent from "../../common/cw-pagination/cw-pagination-v2";
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";
import CommonUtils from "../../../utility/common-utilities";
import SchoolApi from "../../../apis/school";
import CompletionReport from "../completion-report/completion-report";
import ReactTooltip from "react-tooltip";

class ClassAssignmentDetails extends React.Component {


    state = {
        schoolWorkList: [],
        loading: true
    }

    constructor(props) {
        super(props)

        this.getClassAssignmentDetails()
    }

    page = 1
    limit = 10

    getClassAssignmentDetails() {


        if (this.props.isClassSectionWiseReport) {
            let payload = {
                board: this.props.board,
                class: this.props.className
            }

            if (!payload.page) payload.page = this.page

            payload.limit = this.limit

            this.setState({ loading: true })

            SchoolApi.getClassAssignmentDetails(payload).then(res => {
                console.log(res)
                this.setState({ schoolWorkList: res.response, meta: res.meta, loading: false })
                // this.classWiseCompletionDetails = res.classWiseDetails
                // this.setState({ isLoading: false })
            }).catch(err => {
                console.log(err)
            })
        }

        if (this.props.isTeacherReport) {
            let payload = {
                board: this.props.board,
                userId: this.props.userId
            }

            if (!payload.page) payload.page = this.page

            payload.limit = this.limit

            this.setState({ loading: true })

            SchoolApi.getClassAssignmentDetails(payload).then(res => {
                console.log(res)
                this.setState({ schoolWorkList: res.response, meta: res.meta, loading: false })
                // this.classWiseCompletionDetails = res.classWiseDetails
                // this.setState({ isLoading: false })
            }).catch(err => {
                console.log(err)
            })
        }
    }

    datePipe(givenDate, isTime = true) {
        givenDate = new Date(givenDate).toString()
        const [day, month, date, year, time] = givenDate.split(' ')
        return `${date} ${month} ${year} ${isTime ? time.substr(0, 5) : ""}`
    }

    getSchoolworkType(type, category) {

        switch (type) {
            case 'STANDARD_CLASSWORK':
                // Code to execute if expression === value1
                return 'Standard Schoolwork'

            case 'STANDARD':
                // Code to execute if expression === value1
                return 'Standard Schoolwork'

            case 'ADAPTIVE_CLASSWORK':
                return `Adaptive Schoolwork (${category})`

            case 'ADAPTIVE':
                return `Adaptive Schoolwork (${category})`
            // Code to execute if expression === value2

            case 'NORMAL':
                return 'Assessment'

            case 'CLASSWORK_ASSESSMENT':
                return 'Assessment'

            case 'CLICKER_PRACTICE_STANDARD':
                return 'Clicker'

            case 'CLICKER_ASSESSMENT':
                return 'Clicker'

            default:
                return ''
            // Code to execute if no case matches
        }

    }

    showCompletionReport(homeworkId) {
        console.log(homeworkId)

        this.setState({ homeworkId, showCompletionReport: true })

    }

    hideCompletionReport() {
        this.setState({ homeworkId: '', showCompletionReport: false })
    }

    renderRecords() {


        return (
            <div className="">

                <div className="">
                    <span className="header-text"> </span>
                    {/* <span className="float-right cursor-pointer" onClick={this.onClickInfo}>
                        How to redeem reward points?
                    </span> */}
                    {/* <span className="float-right mr-3">
                        <img alt="" className="info-icon mr-1" src={getImageSource(ImageConstants.INFO)} />
                        <span className='engagement-score-text'>Total Engagement Score : {Math.ceil(this.state.reward?.totalPoints || 0)}</span>
                    </span> */}
                </div>

                <div className="pt-2">
                    <div id="table-scoll" className="table-responsive mt-1">
                        <table className="table cw-table">
                            <thead>
                                <tr>
                                    <th className='th-left-radius'>Class</th>
                                    {/* <th>Name</th> */}
                                    <th>Teacher</th>
                                    <th>Chapter / Topic</th>
                                    <th>Creation Date</th>
                                    <th>Due Date</th>
                                    <th>Mode</th>
                                    <th className='th-right-radius'>Completion %</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white">
                                {
                                    this.state.schoolWorkList?.length ? this.state.schoolWorkList?.map(item => (
                                        <tr onMouseEnter={ReactTooltip.rebuild}>
                                            <td>{`${item.class} ${item.section ? item.section : ''}`}</td>
                                            <td>{item.staffName}</td>
                                            <td data-tip={item.chapter ? item.chapter.allConceptNameString : '' }>{item.chapter ? item.chapter.title : item.chapters ? item.chapters[0].title : ''}</td>
                                            <td className="created-date">{this.datePipe(item.createdDate, false)}</td>
                                            <td className="end-date">{this.datePipe(item.endDate, false)}</td>
                                            <td>{this.getSchoolworkType(item.type, item.category)}</td>
                                            <td className="percentage-text cursor-pointer"
                                                onClick={() => this.showCompletionReport(item._id)}>{item.completed.length ? `${Math.ceil((item.completed.length / item.totalUsers) * 100)}%` : '-'}</td>
                                        </tr>
                                    ))
                                        :

                                        <tr>
                                            <td colSpan="5" align='center'> No Records Found</td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='card-footer'>
                    {
                        this.state.meta?.totalPages ?
                            <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta?.totalPages} onPageSelected={this.onPageSelected} /> : ''
                    }
                </div>
            </div>
        )
    }

    renderTeacherRecords() {
        return (
            <div className="">

                <div className="">
                    <span className="header-text"></span>

                </div>

                <div className="pt-2">
                    <div id="table-scoll" className="table-responsive mt-1">
                        <table className="table cw-table">
                            <thead>
                                <tr>
                                    <th className='th-left-radius'>Teacher</th>
                                    {/* <th>Name</th> */}
                                    <th>Class</th>
                                    <th>Chapter / Topic</th>
                                    <th>Creation Date</th>
                                    <th>Due Date</th>
                                    <th>Mode</th>
                                    <th className='th-right-radius'>Completion %</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white">
                                {
                                    this.state.schoolWorkList?.length ? this.state.schoolWorkList?.map(item => (
                                        <tr>
                                            <td>{item.staffName}</td>
                                            <td>{`${item.class} ${item.section ? item.section : ''}`}</td>

                                            <td>{item.chapter ? item.chapter.title : item.chapters ? item.chapters[0].title : ''}</td>
                                            <td className="created-date">{this.datePipe(item.createdDate, false)}</td>
                                            <td className="end-date">{this.datePipe(item.endDate, false)}</td>
                                            <td>{this.getSchoolworkType(item.type)}</td>
                                            <td className="percentage-text cursor-pointer"
                                                onClick={() => this.showCompletionReport(item._id)}>{item.completed.length ? `${Math.ceil((item.completed.length / item.totalUsers) * 100)}%` : '-'}</td>
                                        </tr>
                                    ))
                                        :

                                        <tr>
                                            <td colSpan="5" align='center'> No Records Found</td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='card-footer'>
                    {
                        this.state.meta?.totalPages ?
                            <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta?.totalPages} onPageSelected={this.onPageSelected} /> : ''
                    }
                </div>
            </div>
        )

    }

    onPageSelected = (selectedPage, startIndex) => {
        this.startIndex = startIndex
        this.page = selectedPage

        // this.setPageData()

        this.getClassAssignmentDetails()
    }

    renderHeader() {
        return (

            <div className="row">
                <div className="col"><img className='back-icon cursor-pointer' alt="" src={getImageSource(ImageConstants.BACK_ICON)} onClick={this.props.back} /></div>
                {/* <div className="col text-right">
                        <button className='cw-btn-md d-inline-block cw-btn-blue  mr-2' onClick={this.showRedeemedVoucher} >
                            VOUCHERS REDEEMED
                        </button>
                        <button className='cw-btn-md cw-btn-primary' onClick={this.showRedeem} >
                            REDEEM POINTS
                        </button>
                    </div> */}
            </div>
        )
    }

    render() {

        // if (this.state.showRedeem) return <Redeem reward={this.state.reward} back={this.showRedeem} />
        // if (this.state.showRedeemedVoucher) return <RedeemedVouchers back={this.showRedeemedVoucher} />

        if (this.state.showCompletionReport) {
            return <CompletionReport delegate={this} selectedItem={{ _id: this.state.homeworkId }} />
        }

        return (
            <div className="class-assignment-details">
                {this.state.loading && <Loading />}

                <div>
                    {this.renderHeader()}
                </div>

                <div className="pt-4 d-flex align-items-center">
                    <img className="image-size" src={getImageSource(this.props.isClassSectionWiseReport ? ImageConstants.CLASS_ASSIGNMENT_DETAILS : ImageConstants.TEACHER_ASSIGNMENT_DETAILS)} />
                    <span className='screen-title-new ml-3'>{this.props.isClassSectionWiseReport ? 'Class' : 'Teacher'} Assignment Details</span>
                </div>

                {/* <div className="pt-4">
                    {this.renderPointCard()}
                </div> */}


                {
                    this.props.isClassSectionWiseReport ?
                        <div className="pt-4">
                            {this.renderRecords()}
                        </div>
                        :
                        <></>
                }

                {
                    this.props.isTeacherReport ?
                        <div className="pt-4">
                            {this.renderTeacherRecords()}
                        </div>
                        :
                        <></>
                }


                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </div>);
    }

}

export default ClassAssignmentDetails;